window.NaveeCounter = window.NaveeCounter || (function() {
  // 缓动函数: easeOutExpo
  const easeOutExpo = (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t));

  const animate = (el, target, suffix, duration) => {
    let startTimestamp = null;
    const startValue = 0;

    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      const ease = easeOutExpo(progress);
      
      const current = Math.floor(ease * (target - startValue) + startValue);
      el.innerText = current + suffix;

      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        el.innerText = target + suffix;
      }
    };
    window.requestAnimationFrame(step);
  };

  return {
    // 监听特定容器下的数字元素
    observe: function(containerSelector, itemSelector = '.stat-value') {
      const container = document.querySelector(containerSelector);
      if (!container) return;

      const items = container.querySelectorAll(itemSelector);
      
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const el = entry.target;
            // 防止重复触发
            if (el.dataset.initialized === 'true') return;
            el.dataset.initialized = 'true';

            const target = parseInt(el.getAttribute('data-target')) || 0;
            const suffix = el.innerText.replace(/[0-9]/g, '');
            
            animate(el, target, suffix, 2000);
            observer.unobserve(el);
          }
        });
      }, { threshold: 0.2 });

      items.forEach(item => {
        // 初始化：提取单位并显示 0
        const suffix = item.innerText.replace(/[0-9]/g, '');
        item.innerText = "0" + suffix;
        observer.observe(item);
      });
    }
  };
})();